import { makeStrokeHighlighter } from './strokeHighlight';
import { SELECTION_STROKE, SELECTION_STROKE_WIDTH } from './selectionHighlight';

/**
 * The "this is who you are about to assign it to" highlight, shown while a disease,
 * phenotype or genotype is dragged from the legend onto the chart.
 *
 * It replaces `deselectAllOutlines` / `selectOutline`, which restyled EVERY symbol
 * with an `em` stroke width on each dragover and never took it off again — the
 * reason every node was left with a hairline border after a drop. See
 * strokeHighlight.js for the rules this follows.
 *
 * Its own stash key, so it can sit on top of a Link-to-Existing selection highlight
 * on the same symbol and each restores exactly what it found.
 */
const dropTarget = makeStrokeHighlighter({
  stashKey: '__tgPrevDropStroke',
  width: SELECTION_STROKE_WIDTH,
  colour: SELECTION_STROKE
});

/** Stroke the symbol for canvas `pid`, clearing any previous drop target. */
export const highlightDropTarget = (root, pid, colour) =>
  dropTarget.highlight(root, pid, colour);

/** Put every symbol back exactly as it was before the drag touched it. */
export const clearDropTarget = (root) => dropTarget.clear(root);
